module.exports = __webpack_public_path__ + "static/media/01_registro_fondo_rojo.5c7ceec7.jpg";